function numeroDe(botao) {
  return Number(botao.textContent.trim());
}

function botoesDePagina(el) {
  return Array.from(el.querySelectorAll(".v-pagination__item")).filter((b) => numeroDe(b) > 0);
}

function sincronizar(el) {
  const botoes = botoesDePagina(el);
  if (!botoes.length) return;

  const total = Math.max(...botoes.map(numeroDe));
  const atual = botoes.find((b) => b.getAttribute("aria-current") === "true");
  const pagina = atual ? numeroDe(atual) : null;

  botoes.forEach((botao) => {
    const n = numeroDe(botao);
    botao.setAttribute(
      "aria-label",
      botao === atual ? `Página ${n} de ${total}, página atual` : `Ir para a página ${n} de ${total}`
    );
  });

  if (pagina && el.__paginaAnterior && pagina !== el.__paginaAnterior) {
    el.__paginacaoRegiao.textContent = `Página ${pagina} de ${total}`;
  }
  el.__paginaAnterior = pagina;
}

export default {
  inserted(el) {
    const regiao = document.createElement("span");
    regiao.className = "sr-only";
    regiao.setAttribute("role", "status");
    regiao.setAttribute("aria-live", "polite");
    el.parentNode.insertBefore(regiao, el.nextSibling);
    el.__paginacaoRegiao = regiao;

    sincronizar(el);
    el.__paginacaoObserver = new MutationObserver(() => sincronizar(el));
    el.__paginacaoObserver.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["aria-current"],
    });
  },
  unbind(el) {
    if (el.__paginacaoObserver) el.__paginacaoObserver.disconnect();
    if (el.__paginacaoRegiao) el.__paginacaoRegiao.remove();
    delete el.__paginacaoObserver;
    delete el.__paginacaoRegiao;
    delete el.__paginaAnterior;
  },
};
